import {useAppState} from 'store/utils';

export function useUIStore(): UIState {
  return useAppState().ui;
}
